import React from "react";
// import { FormGroup, Label, Col } from "reactstrap";

// import DatePicker from "reactstrap-date-picker";
// import "react-datepicker/dist/react-datepicker.css";
import { Row, Col, DatePicker } from 'antd';
import 'antd/dist/antd.css';


class FileTraceFilterDatePickers extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      updateSearchData: props.updateSearchData,
      id: props.id,
      value: "",
      labelname: props.labelname,
      maxDate: props.maxDate,
      minDate: props.minDate
    }
  }

  handleChange(value, formattedValue) {
    this.setState({
      value: value, // ISO String, ex: "2016-11-19T12:00:00.000Z"
      formattedValue: formattedValue // Formatted String, ex: "11/19/2016"
    })
    // alert(value+" : "+formattedValue)
    if(formattedValue === ""){
      formattedValue = null;
    }
    // this.state.updateSearchData(this.state.id, formattedValue);
    this.props.updateSearchData(this.props.id, formattedValue, this.props.searchIn, this.props.valuesType);
  }

  render() {
    const dateFormat = 'MM-DD-YYYY';
    return (
      <Row type="flex" justify="center">
        <Col span={6}>{this.state.labelname}</Col>
        <Col span={18}>
          <DatePicker id= {this.state.id}
            onChange={(dateObj,dateString) => {
              //console.log('v',dateObj,'f',dateString)
              this.handleChange(dateObj, dateString);
            }} 
            // disabledDate={ d => !d || d.isAfter(this.state.maxDate) }
            disabledDate={ d => !d || ( this.state.maxDate != null && d.isAfter(this.state.maxDate)) }
            style={{ width: '100%' }}
            placeholder="MM-DD-YYYY" 
            format={dateFormat}
            showToday={false} />
        </Col>
      </Row>
      
      )
  }
}

export default FileTraceFilterDatePickers;


